export default "__VITE_ASSET__xGQ$waEs__"